import { getApiRegionSlug } from "@/common/helper/api-region-slug";
import { MsalService } from "@/common/services/msal-service";
import { applyRegionToUrlTemplate } from "./common/helper/region-url-template";

const msalService = MsalService.getInstance();

export default class EnvironmentVariables {
  private static regionalEnvUrl(viteKey: string): string {
    const raw = (import.meta.env as Record<string, string | undefined>)[
      viteKey
    ];
    return applyRegionToUrlTemplate(raw, getApiRegionSlug()) || "";
  }

  public static SetWindowVariables(): void {
    window.UseAzureAdB2C = import.meta.env.VITE_UseAzureAdB2C || "False";
    window.AzureStorageFileAccountName =
      import.meta.env.VITE_AzureStorageFileAccountName || "";
    window.apiAuthCode = import.meta.env.VITE_apiAuthCode || "";
  }

  public static SetApimSubscriptionKeyVariable(): void {
    window.ApiSubscriptionKey = msalService.apimKey || "";
  }

  static rootCrmClientAPI(): string {
    return this.regionalEnvUrl("VITE_crmApiUrlBase");
  }
  static rootTicketUrlAPI(): string {
    return this.regionalEnvUrl("VITE_ticketApiUrlBase");
  }
  static rootTechnicianUrlAPI(): string {
    return this.regionalEnvUrl("VITE_technicianApiUrlBase");
  }
  static rootFormUrlAPI(): string {
    return this.regionalEnvUrl("VITE_formApiUrlBase");
  }
  static serviceProviderApiUrlBase(): string {
    return this.regionalEnvUrl("VITE_serviceProviderApiUrlBase");
  }
  static documentApiUrlBase(): string {
    return this.regionalEnvUrl("VITE_documentApiUrlBase");
  }
  static billingApiUrlBase(): string {
    return this.regionalEnvUrl("VITE_billingApiUrlBase");
  }
  static rootAzureBlob(): string {
    return this.regionalEnvUrl("VITE_azureBlobUrlBase");
  }
  static checkVersionUrl(): string {
    return this.regionalEnvUrl("VITE_checkVersionUrl");
  }
  // static azureFunctionUrl(): string {
  //   return import.meta.env.VITE_AzureFunctionUrl || "";
  // }
  static publicFunctionUrl(): string {
    return this.regionalEnvUrl("VITE_PublicFunctionUrl");
  }
  static azureStorageFileAccountName(): string {
    return import.meta.env.VITE_AzureStorageFileAccountName || "";
  }
  static getApimUrl(): string {
    return this.regionalEnvUrl("VITE_apimUrl");
  }
  static getAppInsightKey(): string {
    return import.meta.env.VITE_appInsightsKey || "";
  }
  static getSignInRedirectUI(): string {
    return import.meta.env.VITE_signInRedirectUI || "";
  }
  static reportApiUrlBase(): string {
    return this.regionalEnvUrl("VITE_reportApiUrlBase");
  }
  static projectApiUrlBase(): string {
    return this.regionalEnvUrl("VITE_projectApiUrlBase");
  }
  static environment(): string {
    return import.meta.env.VITE_environment || "";
  }
}
